import * as React from 'react'
import { APP_TITLE } from '../../utils/constants'
import { Helmet } from 'react-helmet'
import { IPageTitle } from './interface'

const PageTitle = ({ title }: IPageTitle) => (
  <Helmet>
    <title>{`${title}${title ? ' – ' : ''}${APP_TITLE}`}</title>
  </Helmet>
)

export default PageTitle
